const refreshUri = process.env.REACT_APP_API_ENTRYPOINT + '/token_refresh';
export default async () => {
    let refresh_token = localStorage.getItem('refresh_token');

    if (refresh_token) {
        const request = new Request(`${refreshUri}`, {
            method: 'POST',
            body: `refresh_token=${refresh_token}`,
            headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }),
        });
        return fetch(request)
        .then(response => {
            if (response.status < 200 || response.status >= 300) throw new Error(response.statusText);
            return response.json();
        }).then(({ token }) => {
            localStorage.setItem('token', token);
        })
    } else {
        return Promise.reject();
    }
}



// WEBPACK FOOTER //
// ./src/security/refreshToken.js